<template>
	<div class="loading" v-if="isVisible">
		<div class="flex xs-center xs-middle p2 bgWarning c1 fs4 loading-inner">
			<div>
				{{ $t("loading") }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		delay: {
			type: Number,
			required: false,
			default: 250
		}
	},
	data() {
		return {
			isVisible: false
		}
	},
	mounted() {
		let timeout = setTimeout(() => (this.isVisible = true), this.delay)
	}
}
</script>

<style scoped>
@import "../../assets/css/tokens.css";

/* Display loading with 400ms delay - handled by animation */
.loading {
	width: 100%;
	display: flex;
	justify-content: center;
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 100;
	opacity: 0;
	animation: loading 200ms ease-out;
	animation-fill-mode: forwards;
}

.loading-inner {
	width: 120px;
}

@keyframes loading {
	0% {
		transform: translateY(10px);
		opacity: 0;
	}
	100% {
		transform: translateY(0);
		opacity: 1;
	}
}
</style>
